/** 発着地の種別。 */
export enum PointType {
  STATION = 'station',
  COORDINATE = 'coordinate',
  ADDRESS = 'address',
  CURRENT_POSITION = 'currentPosition',
  SELECT_ON_MAP = 'selectOnMap',
  NONE = '',
  HISTORY = 'history',
}
